// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"7a6fbe50","198":"082347b1","498":"b16c349d","608":"9ab615c3","703":"4e57615b"}[chunkId] + ".chunk.js";
};